import React from 'react';
import PropTypes from 'prop-types';
import { Button, Space } from 'antd';
import TableWithSorter from '../../../../components/Common/TableWithSorter';

const EmailTemplatesTable = ({
  loading,
  totalCount,
  onPaginationChange,
  data,
  onTemplateSelect,
  offset,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'Name',
      dataIndex: 'mailType',
      key: 'mailType',
      render: (text, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => onTemplateSelect(record)}>
            {record.mailType}
          </Button>
        </Space>
      ),
    },
    {
      title: 'Subject',
      dataIndex: 'mailSubject',
      key: 'mailSubject',
    },
    {
      title: 'Content Source',
      dataIndex: 'mailContentSource',
      key: 'mailContentSource',
    },
    {
      title: 'Course',
      dataIndex: 'mailCourse',
      key: 'mailCourse',
    },
    {
      title: 'Course Offer',
      dataIndex: 'mailCourseOffer',
      key: 'mailCourseOffer',
    },
    {
      title: 'Type',
      dataIndex: 'recordType',
      key: 'recordType',
    },
    {
      title: 'Attachment',
      dataIndex: 'hasMailAttachment',
      key: 'hasMailAttachment',
      render: (text, record) => (record.hasMailAttachment ? 'yes' : 'no'),
    },
  ];

  return (
    <section>
      <TableWithSorter
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        loading={loading}
        dataSource={data}
        columns={columns}
        pagination={{
          total: totalCount,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
        }}
        onChange={onPaginationChange}
      />
    </section>
  );
};

EmailTemplatesTable.propTypes = {
  loading: PropTypes.bool,
  totalCount: PropTypes.number,
  onPaginationChange: PropTypes.func.isRequired,
  data: PropTypes.array,
  onTemplateSelect: PropTypes.func,
};

EmailTemplatesTable.defaultProps = {
  totalCount: 0,
  data: [],
};

export default EmailTemplatesTable;
